import * as types from '../mutation-types'
import { API } from '../../api'
import { DONATE_DATA_MANAGER } from '../../data'
import { WEIXIN_PAY } from '../../weixin'
import { UTILS } from '../../utils'
import { MOMENT_TIME } from '../../momenttime'

export default {
    namespaced: true,
    state: {
        showActSixOneEightBtn: false,
        actSixOneEightPopShowed: false,
        showActSixOneEightPop: false,
        showActSixOneEightSecondPop: false,
        showActAlwaysDiscountPop: false,
        showActNewUserBtn: false,
        showActNewUserPop: false,
        showActNewUserSecondPop: false,
        activityInfo: {},
        actCountDownTime: 0,
        actCountDownTimeStr1: '',
        actCountDownTimeStr2: '',
        actCountDownFunc: null,
        actCountDownNumber: 1,
        actCountDownTime2: 0,
        actCountDownFunc2: null,
        newUserActivityInfo: {},
        newUserCountDownTime: 0,
        newUserCountDownTimeStr1: '',
        newUserCountDownUpdateTime: 0,
        newUserCountDownFunc: null,
    },
    getters: {},
    mutations: {
        [types.ACTIVITY_618_VIP_COUNT_DOWM_TIME](state) {
            // 跑倒计时
            state.actCountDownFunc = setTimeout(count, 1000);
            function count() {
                state.actCountDownTime--;
                state.actCountDownTimeStr1 = UTILS.getCountDownTimeStr(state.actCountDownTime, 1);
                state.actCountDownTimeStr2 = UTILS.getCountDownTimeStr(state.actCountDownTime, 2);
                clearTimeout(state.actCountDownFunc);
                if(state.actCountDownTime > 0) {
                    state.actCountDownFunc = setTimeout(count, 1000)
                }else if(state.actCountDownTime == 0) {
                    // 时间跑完了
                    state.showActSixOneEightBtn = false;
                    state.showActSixOneEightPop = state.activityInfo && state.activityInfo.img_998 && !state.actSixOneEightPopShowed ? true : false;
                }
            }
        },
        [types.ACTIVITY_618_VIP_COUNT_DOWM_NUMBER](state) {
            // 跑倒计时
            // for test
            // let countTime = 1000; 
            let countTime = (0+state.actCountDownTime2)*1000;
            let now = MOMENT_TIME.getTimeArrayByTimeStamp();
            let nowStr = 'num-' + now.slice(0, 3).join('-');
            // 将次数写入缓存
            let actInfo = {};
            actInfo[nowStr] = state.actCountDownNumber;
            window.localStorage.setItem('h5_vip_act_info', JSON.stringify(actInfo));
            console.error('ACTIVITY_618_VIP_COUNT_DOWM_NUMBER', state.actCountDownNumber, state.actCountDownTime2, countTime);
            state.actCountDownFunc2 = setTimeout(count, countTime);
            function count() {
                state.actCountDownNumber--;
                // 将次数写入缓存
                let actInfo = {};
                actInfo[nowStr] = state.actCountDownNumber;
                window.localStorage.setItem('h5_vip_act_info', JSON.stringify(actInfo));
                console.log('count-----', actInfo)
                clearTimeout(state.actCountDownFunc2);
                if(state.actCountDownNumber > 1) {
                    state.actCountDownFunc2 = setTimeout(count, countTime)
                }else if(state.actCountDownNumber == 1) {
                    // 最后一次
                    state.showActSixOneEightBtn = false;
                    state.showActSixOneEightPop = state.activityInfo && state.activityInfo.img_998 && !state.actSixOneEightPopShowed ? true : false;
                }
            }
        },
    },
    actions: {
        initActSetting({ state }, params) {
            state.actSixOneEightPopShowed = params['act_h5_618_pop'] && parseInt(params['act_h5_618_pop']) == 1 ? true : false;
            console.log('initActSetting------', state.actSixOneEightPopShowed);
        },
        getActivityInfo({ dispatch, commit, state }, params) {
            API.getActivityInfo({}, (data)=> {
                console.log("获取活动信息成功-------", data, params);
                state.activityInfo = Object.assign({}, data);
                // 是否展示过第一次
                state.showActSixOneEightPop = data && parseInt(data.open) == 1 && !state.actSixOneEightPopShowed ? true : false;
                console.log('state.showActSixOneEightPop----', state.showActSixOneEightPop);
                if(params.hideAct) {
                    state.showActSixOneEightBtn = false;
                    state.showActSixOneEightPop = false;
                    return;
                }
                // 倒计时时间
                if(state.activityInfo.show_type == 1) {
                    state.actCountDownTime = data ? parseInt(data.day_down) : 0;
                    state.actCountDownTimeStr1 = UTILS.getCountDownTimeStr(state.actCountDownTime, 1);
                    state.actCountDownTimeStr2 = UTILS.getCountDownTimeStr(state.actCountDownTime, 2);
                    commit(types.ACTIVITY_618_VIP_COUNT_DOWM_TIME);
                // 倒计时次数
                }else if(state.activityInfo.show_type == 2) {
                    state.actCountDownNumber = data ? parseInt(data.day_num) : state.actCountDownNumber;
                    let actInfoLS = window.localStorage.getItem('h5_vip_act_info');
                    let actInfoLSObj = actInfoLS && actInfoLS != '' ? JSON.parse(actInfoLS) : null;
                    let now = MOMENT_TIME.getTimeArrayByTimeStamp();
                    let nowStr = 'num-' + now.slice(0, 3).join('-');
                    let todayNumberLS = actInfoLSObj && actInfoLSObj[nowStr] ? actInfoLSObj[nowStr] : 0;
                    state.actCountDownNumber = todayNumberLS != 0 ? todayNumberLS : state.actCountDownNumber;
                    state.actCountDownTime2 = data ? parseInt(data.interval) : 0;
                    if(state.actCountDownNumber > 1) {
                        commit(types.ACTIVITY_618_VIP_COUNT_DOWM_NUMBER);
                    }
                }
                // console.log('获取活动信息成功--------', data, state.activityInfo, state.actCountDownTime, endTime, nowTime);
            })
        },
        updateActivityShowBtnStatus({ state }) {
            let endTime = MOMENT_TIME.getUnixTimeByTimeStr(state.activityInfo.end_time);
            let nowTime = MOMENT_TIME.getTimeStampByNow();
            if(state.activityInfo.show_type == 1) {
                state.showActSixOneEightBtn = nowTime < endTime && state.actCountDownTime > 0;
            }else if(state.activityInfo.show_type == 2) {
                state.showActSixOneEightBtn = nowTime < endTime && state.actCountDownNumber > 1;
            }
            console.log('updateActivityShowBtnStatus-----', state.showActSixOneEightBtn)
        },
        initNewUserPopup({ state, dispatch }, params) {
            state.newUserActivityInfo = params && params.pay && params.pay.vip_full ? Object.assign(params, {
                second: params.second,
                entry: params.pay.vip_full.entry,
                bg: params.pay.vip_full.bg,
                bg_save: params.pay.vip_full.bg_save,
            }) : params;
            console.log('initNewUserPopup-------', params, state.newUserActivityInfo);
            state.showActNewUserPop = true;
            state.newUserCountDownTime = state.newUserActivityInfo ? parseInt(state.newUserActivityInfo.second) : 0;
            state.newUserCountDownTimeStr1 = UTILS.getCountDownTimeStr(state.actCountDownTime, 1);
            dispatch('runNewUserCountDown');
        },
        runNewUserCountDown({state, dispatch}) {
            // 跑倒计时
            state.newUserCountDownFunc = setTimeout(count, 1000);
            function count() {
                // 每5秒提交一次更新
                if(state.newUserCountDownUpdateTime == 5) {
                    dispatch('report/updateReportAIShowTime', {second: state.newUserCountDownTime, type: 6}, {root: true});
                    state.newUserCountDownUpdateTime = 0;
                }
                state.newUserCountDownTime--;
                state.newUserCountDownUpdateTime++;
                state.newUserCountDownTimeStr1 = UTILS.getCountDownTimeStr(state.newUserCountDownTime, 1);
                clearTimeout(state.newUserCountDownFunc);
                if(state.newUserCountDownTime > 0) {
                    state.newUserCountDownFunc = setTimeout(count, 1000)
                }else if(state.newUserCountDownTime == 0) {
                    // 时间跑完了
                    dispatch('report/updateReportAIShowTime', {second: state.newUserCountDownTime, type: 6}, {root: true});
                    state.showActNewUserBtn = false;
                    state.showActNewUserPop = true;
                }
            }
        },
        resetActivityData({ state }) {
            state.showActSixOneEightBtn = false;
            state.showActSixOneEightPop = false;
            state.showActAlwaysDiscountPop = false;
            state.activityInfo = {};
            state.actCountDownTime = 0;
            state.actCountDownTimeStr1 = '';
            state.actCountDownTimeStr2 = '';
            clearTimeout(state.actCountDownFunc);
            state.actCountDownFunc = null;
            state.actCountDownNumber = 10;
        },
        resetNewUserActivityData({ state }) {
            state.showActNewUserBtn = false;
            state.showActNewUserPop = false;
            state.showActNewUserSecondPop = false;   
            state.newUserActivityInfo = {};
            state.newUserCountDownTime = 0;
            state.newUserCountDownTimeStr1 = '';
            state.newUserCountDownFunc = null;
        }
    }
}